import React from 'react'

import { Box, Text, theme } from '@factorialco/deprecated-design-system'
import { Button } from '@factorialco/factorial-one-react'
import { EmojiAvatar } from '@factorialco/factorial-one-react/dist/experimental'
import { Cross } from '@factorialco/factorial-one-react/icons/app'
import { InAppCommsBanner, Maybe } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import CommsButton from '../CommsButton'

interface BannerProps {
  content: Maybe<InAppCommsBanner> | undefined
  componentName: string
  onDismiss: () => void
}

const Banner = ({ content, componentName, onDismiss }: BannerProps) => {
  const handleClose = () => {
    onDismiss()
    track(trackingEvents.inAppComms.dismissInAppCommsComponent, {
      component: 'in_app_comms_banner',
      componentName,
    })
  }

  useEffect(() => {
    if (!content?.title) return
    track(trackingEvents.inAppComms.viewInAppCommsComponent, {
      component: 'in_app_comms_banner',
      componentName,
    })
  }, [content?.title, componentName])

  if (!content) return null

  return (
    <Box
      flexDirection="row"
      position="relative"
      width="full"
      padding="s6"
      background="grey000White"
      gap="s6"
      style={{
        marginBottom: theme.dimensions.s8,
        borderBottom: '1px dashed',
        borderColor: theme.colors.grey300,
        zIndex: theme.zIndex.modals,
        left: '0',
        right: '0',
        top: '0',
      }}
    >
      <Box flexDirection="row" alignItems="center" justifyContent="center" width="full" gap="s32">
        <Box flexDirection="row" alignItems="center" gap="s8">
          {content.icon && <EmojiAvatar emoji={content.icon} size="md" />}
          <Box flexDirection="row" alignItems="center" gap="s8" flexWrap="wrap">
            <Text.Normal size="200" weight="semibold" color="grey1000">
              {content.title}
            </Text.Normal>
            <Text.Normal size="200">{content.description}</Text.Normal>
          </Box>
        </Box>
        <Box flexDirection="row" gap="s8">
          {content.buttons.map((button, index) => {
            return (
              <CommsButton
                key={index}
                button={button}
                variant="default"
                size={content.icon ? 'md' : 'sm'}
                componentType="in_app_comms_banner"
                componentName={componentName}
                onClick={() => onDismiss()}
              />
            )
          })}
        </Box>
      </Box>
      <Box alignSelf="flexStart" paddingRight="s16">
        <Button
          onClick={handleClose}
          variant="ghost"
          size="md"
          icon={Cross}
          hideLabel
          round
          label="Ghost"
        />
      </Box>
    </Box>
  )
}

export default Banner
